// Re-export from users API for backward compatibility
import usersAPI from './users';

class AuthAPI {
  async signup(email, password) {
    return usersAPI.signup(email, password);
  }
  
  async login(email, password) {
    return usersAPI.login(email, password);
  }
  
  async getUserById(userId) {
    return usersAPI.getUserById(userId);
  }
  
  async getUserByEmail(email) {
    return usersAPI.getUserByEmail(email);
  }
  
  async updateUser(userId, userData) {
    return usersAPI.updateUser(userId, userData);
  }
  
  async deleteUser(userId) {
    return usersAPI.deleteUser(userId);
  }
}

export default new AuthAPI();
